export const MINIMUM_DONATION = 5;
export const MAXIMUM_DONATION = 250000;
export const MAXIMUM_FILE_SIZE_IN_MB = 10; // 10 MB
export const MAXIMUM_FILE_SIZE = MAXIMUM_FILE_SIZE_IN_MB * 1000 * 1000;
export const MAXIMUM_FILE_SIZE_EXCEEDED_MSG = `${MAXIMUM_FILE_SIZE_IN_MB}MB file size limit exceeded.`;
